import type { Observable } from 'rxjs';
import type {
  RegistryOtpGenerateParams,
  RegistryOtpGenerateResult,
  RegistryOtpValidateParams,
  RegistryOtpValidateResult,
} from '../models/registry-otp.model';

export abstract class RegistryOtpPort {
  abstract generate(params: RegistryOtpGenerateParams): Observable<RegistryOtpGenerateResult>;

  abstract validate(params: RegistryOtpValidateParams): Observable<RegistryOtpValidateResult>;
}
